module.exports = __webpack_public_path__ + "img/Veranza-1-min.7c647e31.jpg";